import { useEffect } from "react";
import {
  getTotalYearGrossMarginYear1,
  getTotalYearGrossMarginYear2,
  getTotalYearGrossMarginYear3,
} from "../Redux/Actions/totalYearGrossMarginPerYear";

export const TotalYearGrossMarginPerYear = (data, dispatch) => {
  //#region add all amounts in "Produktmixern", per year
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function addTotalYearGrossMarginPerYear(year) {
        try {
          const total = data?.data
            .filter((item) => item.year === year)
            .map(
              (item) =>
                //math formula: (price - variablecost) * volumeYear
                (parseFloat(item.object.price) -
                  parseFloat(item.object.variableCost)) *
                parseFloat(item.object.volumeYear)
            )
            //add sum of each row
            .reduce((acc, curr) => acc + parseFloat(curr, 10), 0);
          if (year === "year1") {
            dispatch(getTotalYearGrossMarginYear1(total));
          }
          if (year === "year2") {
            dispatch(getTotalYearGrossMarginYear2(total));
          }
          if (year === "year3") {
            dispatch(getTotalYearGrossMarginYear3(total));
          }
        } catch (err) {}

      }
      addTotalYearGrossMarginPerYear("year1");
      addTotalYearGrossMarginPerYear("year2");
      addTotalYearGrossMarginPerYear("year3");
    }
    return () => {
      isMounted = false;
    };
  }, [data, dispatch]);
  //#endregion add all amounts in "Produktmixern", per year
};
